module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "contato"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Contato")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticClass: "phone"
  }, [_vm._v("(84) 3215-3305 / 3208")]), _c('p', {
    staticClass: "email"
  }, [_vm._v("secretariaproad@reitoria.ufrn.br")]), _c('p', {
    staticClass: "infos"
  }, [_vm._v("Para mais informações, dúvidas e/ou sugestões entre em contato através do formulário abaixo:")]), _c('formulario', {
    attrs: {
      "destino": 'proad'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67fe169e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Contato.vue
// module id = 497
// module chunks = 0